module.exports = __webpack_public_path__ + "img/back3x.85769115.png";